import React, {useEffect, useMemo}          from 'react'
import {Box, Typography, useTheme} from '@mui/material'
import {Navigate, useParams}                     from 'react-router-dom'
import {useUserStore}                            from '../../state'
import {getApiUrl}                                            from "../../util/do-fetch"
import getSupabase                                            from "../../util/supabase-utils"


let runThenDelete = async (packageToken) => {
	const session = await getSupabase().auth.getSession()
	const token = session.data.session.access_token
	const url = getApiUrl(`/mini/package/${packageToken}/try?token=${token}`)
	window.location.replace(url)
}

const TryPackageScreen = () => {
	const theme = useTheme()
	const {user, authLoaded} = useUserStore()
	const {categoryToken, packageToken} = useParams()

	useEffect(() => {
		console.log(`useEffect[${user?.id}, ${packageToken}]`)
		if (!user?.id || !packageToken) return
		runThenDelete(packageToken)
		runThenDelete = async () => { console.error("RUN THEN DELETE")}
	}, [user?.id, packageToken])

	const packageTitle = useMemo(() => {
		return packageToken &&
			packageToken.split('-')
				.map(w => w.charAt(0)
					.toUpperCase() + w.slice(1))
				.join(' ')
	}, [packageToken])

	return (
		<Box
			display="flex"
			mt={-3}
			minWidth="100vw"
			minHeight="calc(100vh - 80px)"
			flexDirection="column"
			justifyContent="flex-start"
			alignItems="center"
			border="0px solid red"
			bgcolor={theme.palette.background.paper}
		>
			{
				authLoaded && !user &&
				<Navigate to={`/login?next=/try/${categoryToken}/${packageToken}`} replace />
			}
		</Box>
	)
}

export default TryPackageScreen
